import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { catchAsync } from 'helpers';

export const deleteUserById = createAsyncThunk(
  'users/deleteUserById',
  catchAsync(async (id, thunkAPI) => {
    const res = await axios.delete(`/users/${id}`);
    return res.data;
  })
);
